import { render, staticRenderFns } from "./create-merchant.vue?vue&type=template&id=7ed4454e&"
import script from "./create-merchant.vue?vue&type=script&lang=ts&"
export * from "./create-merchant.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "create-merchant.vue"
export default component.exports